import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import LoginLayout from "../layouts/LoginLayout";
import SignUp from "../pages/auth/SignUp";
import Login from "../pages/auth/Login";
import Dashboard from "../pages/dashboard/Dashboard";
import SidebarLayout from "../layouts/SidebarLayout";
import PrivateRoute from "./PrivateRoute";
import OliPrivateRoute from "./OliPrivateRoute";
import Project from "../pages/dashboard/project/Project";
import Role from "../pages/role/Role";
import Integration from "../pages/integration/Integration";
import Configurator from "../pages/configurator/Configurator";
import { useEffect, useState } from "react";
import ConfiguratorProject from "../pages/configurator/forms/ConfiguratorProject";
import { useAuth } from '../hooks/AuthContext';
import {checkRoleUpdation,updateRoleUpdation} from "../services/apiService";
import Repo from '../pages/repo/Repo'
import Convoai from "../pages/Convoai";
import SwitchConfiguratorPrototype from '../pages/SwitchConfiguratorPrototype'
import ARView from "./ARView";
import ModelViewer from "./ModelViewer";
import CustomGPT from "../pages/CustomGPT";
import ChatInterface from "../pages/ChatInterface";
import TvsChatInterface from "../pages/TvsChatInterface";
import TvsChatInterface2 from "../pages/TVSChatInterface2";
import TvsChatInterface3 from "../pages/TVSChatInterface3";
import TvsChatInterface4 from "../pages/TVSChatInterface4";
import ManagerAI from "../pages/ManagerAI";
import PmmAI from "../pages/PmmAI";
import TwoWayAIChatBot from "../pages/TwoWayAIChatBot";
import CallAI from "../pages/CallAI";
import CallAI2 from "../pages/CallAI2";
import PptAI from "../pages/PptAI";
import SchneiderAI from "../pages/SchneideraAI";
import MauiV2 from "../pages/MauiV2";
import MauiV3 from "../pages/MauiV3";
import AgriAI from "../pages/AgriAI";
import MauiLaptopV1 from "../pages/MauiLaptopV1";
import MauiVoice from "../pages/MauiVoice";
import MauiVoice2 from "../pages/AudioStream";
import MauiV4 from "../pages/MamAI";
import PostCallMaui from "../pages/PostCallMaui";
import MauiDashboard from "../pages/MauiDashboard";
import MauiPrePostCallSummery from "../pages/MauiPrePostCall";
import AvironixTest from "../pages/AvironixTest";
import OliProductSelectionPage from "../pages/OliProductSelectionPage";
import OliUsersPage from "../pages/OliUsersPage";
import OliLogin from "../pages/auth/Oli_login";
import OliConfigurator from "../pages/OliConfigurator";
import AvironixDashboard from "../pages/AvironixDashboard";
// import DynamicQr from "./DynamicQr";


function MainContent() {
    const [error, setError] = useState<string | null>(null);
    const [isError, setIsError] = useState<boolean>(false);
    const location = useLocation();
    const hideSidebarRoutes = ['/login', '/signup', '/logout'];
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isOliAuthenticated, setIsOliAuthenticated] = useState(false);

    const shouldHideSidebar = hideSidebarRoutes.includes(location.pathname);
    const { logout } = useAuth();
    async function checkRoleUpdationfun() { 
      return await checkRoleUpdation(localStorage.getItem('id')); 
    }
    useEffect(() => { 
      const checkRole = async () => { 
        const result = await checkRoleUpdationfun(); 
        if(result.role_update == 'true'){
            setIsAuthenticated(false);
            logout()
        }
      }; 
      const intervalId = setInterval(checkRole, 600000); 
      return () => clearInterval(intervalId); 
    }, []);

    useEffect(() => {
      if (localStorage.getItem('isLoggedIn') === 'true') {
        setIsAuthenticated(true);
      }

      if (localStorage.getItem('isOliLoggedIn') === 'true') {
        setIsOliAuthenticated(true);
      }
    }, []);

    const aa = window.location.pathname.replace(/^\/+/, '') === "OliLogin" ? false : true;
      
    return (
      shouldHideSidebar ? (
        <LoginLayout isError={isError} error={error} setIsError={setIsError}>
          <Routes>
            <Route path="/login" element={<Login setError ={setError} setIsError={setIsError}/>} />
            <Route path="/signup" element={<SignUp  setError ={setError} setIsError={setIsError}/>} />
          </Routes>
        </LoginLayout>) : (
          aa ? <SidebarLayout isError={isError} error={error} setIsError={setIsError}>
          <Routes>
            <Route path="/convoai" element={<PrivateRoute element={<Convoai/>} />} />
            <Route path="/ARView" element={<PrivateRoute element={<ARView/>} />} />
            <Route path="/CustomGPT" element={<PrivateRoute element={<CustomGPT/>} />} />
            <Route path="/AstraAIBot" element={<PrivateRoute element={<ChatInterface/>} />} />
            <Route path="/TVSAIChatBot" element={<PrivateRoute element={<TvsChatInterface/>} />} />
            <Route path="/TVSAIChatBot2" element={<PrivateRoute element={<TvsChatInterface2/>} />} />
            <Route path="/TVSAIChatBot3" element={<PrivateRoute element={<TvsChatInterface3/>} />} /> 
            <Route path="/TVSAIChatBot4" element={<PrivateRoute element={<TvsChatInterface4/>} />} />
            <Route path="/traningAI" element={<PrivateRoute element={<ManagerAI/>} />} />  
            <Route path="/SchneiderAI" element={<PrivateRoute element={<SchneiderAI/>} />} />
            <Route path="/PmmAI" element={<PrivateRoute element={<PmmAI/>} />} /> 
            <Route path="/TwoWayAIChatBot" element={<PrivateRoute element={<TwoWayAIChatBot/>} />} /> 
            <Route path="/CallAI" element={<PrivateRoute element={<CallAI/>} />} />
            <Route path="/V2CAI" element={<PrivateRoute element={<CallAI2/>} />} />
            <Route path="/PptAI" element={<PrivateRoute element={<PptAI/>} />} />
            <Route path="/MauiXXoro" element={<PrivateRoute element={<MauiV2/>} />} />
            <Route path="/MauiXMaui" element={<PrivateRoute element={<MauiV3/>} />} />
            <Route path="/MauiXMaui-laptop" element={<PrivateRoute element={<MauiLaptopV1/>} />} />
            <Route path="/MauiVoice" element={<PrivateRoute element={<MauiVoice/>} />} />
            <Route path="/MauiVoice2" element={<PrivateRoute element={<MauiVoice2/>} />} />
            <Route path="/Maui4" element={<PrivateRoute element={<MauiV4/>} />} />
            <Route path="/PostCallMaui" element={<PrivateRoute element={<PostCallMaui/>} />} />
            <Route path="/Drone" element={<PrivateRoute element={<AgriAI/>} />} /> 
            <Route path="/Avironix" element={<AvironixTest/>} />
            <Route path="/avironixDashboard" element={<PrivateRoute element={<AvironixDashboard/>} />} /> 
            
            {/* <Route path="/ModelViewer" element={<PrivateRoute element={<ModelViewer/>} />} /> */}
            <Route path="/SwitchConfiguratorPrototype" element={<PrivateRoute element={<SwitchConfiguratorPrototype/>} />} />
            <Route path="/dashboard" element={<PrivateRoute element={<Dashboard setError ={setError} setIsError={setIsError}/>} />} />
            <Route path="/dashboard/projects" element={<PrivateRoute element={<Project setError ={setError} setIsError={setIsError}/>} />} />
            <Route path="/configurator" element={<PrivateRoute element={<Configurator setError ={setError} setIsError={setIsError}/>} />} />
            <Route path="/3drepo" element={<PrivateRoute element={<Repo setError ={setError} setIsError={setIsError}/>} />} />
            <Route path="/configurator/form" element={<PrivateRoute element={<ConfiguratorProject setError ={setError} setIsError={setIsError}/>} />} />
            <Route path="/integration" element={<PrivateRoute element={<Integration />} />} />
            <Route path="/roles" element={<PrivateRoute element={<Role setError ={setError} setIsError={setIsError}/>} />} />
            {/* <Route path="/dynamicqr" element={<DynamicQr/>}/> */}

            
            <Route path="/OliProducts" element={<OliPrivateRoute element={<OliProductSelectionPage />} />} />
            <Route path="/OliProductCustomers" element={<OliPrivateRoute element={<OliUsersPage />} />} />
            <Route path="/MauiDashboard" element={<OliPrivateRoute element={<MauiDashboard />} />} />
            <Route path="/oliCallTracking" element={<OliPrivateRoute element={<MauiPrePostCallSummery />} />} />
            <Route path="/oliConfigurator" element={<OliPrivateRoute element={<OliConfigurator />} />} />
            

            <Route path="/" element={<Navigate to={isAuthenticated ? `${localStorage.getItem("ai_access") === "astra" ? "/AstraAIBot" : localStorage.getItem("ai_access") === "tvs" ? "/TVSAIChatBot" : localStorage.getItem("ai_access") === "tvs2" ? "/TVSAIChatBot2" : localStorage.getItem("ai_access") === "traningAI" ? "/traningAI" : localStorage.getItem("ai_access") === "PmmAI" ? "/PmmAI" : localStorage.getItem("ai_access") === "twai" ? "/TwoWayAIChatBot": localStorage.getItem("ai_access") === "sch" ? "/SchneiderAI": localStorage.getItem("ai_access") === "callai" ? "/CallAI": localStorage.getItem("ai_access") === "callai2" ? "/V2CAI": localStorage.getItem("ai_access") === "MauiXMaui" ? "/MauiXMaui":localStorage.getItem("ai_access") === "Drone" ? "/Drone": localStorage.getItem("ai_access") === "MauiXMaui-laptop" ? "/MauiXMaui-laptop":localStorage.getItem("ai_access") === "Maui4" ? "/Maui4" : localStorage.getItem("ai_access") === "Avironix" ? "/Avironix": localStorage.getItem("ai_access") === "AvironixDashboard" ? "/avironixDashboard": "/dashboard?page=1"}` : "/login"} />} />
          </Routes>
       </SidebarLayout>
       :
       <Routes>
          <Route path="/OliLogin" element={<OliLogin isOliAuthenticated={isOliAuthenticated} />} />
       </Routes>
       )
    );
  }

  export default MainContent;